import { CoreModule, LazyModuleFactory, ShowPasswordDirective } from '@abp/ng.core';
import { ThemeSharedModule } from '@abp/ng.theme.shared';
import { ModuleWithProviders, NgModule, NgModuleFactory } from '@angular/core';
import {
  NgbAccordionModule,
  NgbCollapseModule,
  NgbDatepickerModule,
  NgbDropdownModule,
} from '@ng-bootstrap/ng-bootstrap';
import { NgxValidateCoreModule } from '@ngx-validate/core';
import { CommercialUiModule } from '@volo/abp.commercial.ng.ui';
import { PageModule } from '@abp/ng.components/page';
import { UserComponent } from './user/user.component';
import {
  IdentityModule,
  InviteUsersModalComponent,
  UploadExcelFileComponent,
} from '@volo/abp.ng.identity';
import { PermissionManagementModule } from '@abp/ng.permission-management';

import { NgbNavModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { ExtensibleDateTimePickerComponent } from '@abp/ng.components/extensible';
import { TreeModule } from '@abp/ng.components/tree';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@/shared/shared.module';
import { EventTypesComponent } from './user/event-types/event-types.component';
import { UserModalComponent } from './user/user-modal/user-modal.component';
import { UserTableComponent } from './user/user-table/user-table.component';

@NgModule({
  declarations: [UserComponent, EventTypesComponent, UserModalComponent, UserTableComponent],
  imports: [
    FormsModule,
    CommercialUiModule,
    CoreModule,
    IdentityModule,
    InviteUsersModalComponent,
    UploadExcelFileComponent,
    NgbCollapseModule,
    NgbDatepickerModule,
    NgbDropdownModule,
    NgbAccordionModule,
    NgbNavModule,
    SharedModule,
    NgxValidateCoreModule,
    PageModule,
    PermissionManagementModule,
    ShowPasswordDirective,
    ThemeSharedModule,
    TreeModule,
    ExtensibleDateTimePickerComponent,
    NgbTooltipModule,
  ],
  exports: [UserComponent],
})
export class UserModule {}
